import { SIGNIN, ERROR } from "../actions/actionsTypes";

const signinReducer = (state = [], action) => {
  switch (action.type) {
    case SIGNIN: {
      return action.payload;
    }
    case ERROR: {
      return action.payload
    }
    default: {
      return state;
    }
  }
};

export default signinReducer;



// WEBPACK FOOTER //
// ./src/reducers/signin.js